export default __webpack_public_path__ + "/dist/images/copy-link.6969c66a7f2b58f6e6284bd8420f5cf5.svg";